function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 24.11C15.28 36.87 0 27.85 0 27.85s7.56-.57 10.49-2.93c0 0-5.45-2.84-6.83-6.58 0 0 2.19 1.06 2.76.9 0 0-4.88-4-5.36-7.4a7.64 7.64 0 0 0 3 .48S-.08 6.07 2.36 1.6c0 0 5.47 8.61 16.27 8 0 0-.09-8.74 6.81-9.59a7.68 7.68 0 0 1 6.5 2.68L36.58.54l-2 3.74h3.17l-3.9 3.25A21.48 21.48 0 0 1 28 24.11z",
  fill: "#ddd33d",
  "data-name": "Layer 1"
}));

var SvgTwitterIcon = function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37.79 30.94"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNy43OSAzMC45NCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNkZGQzM2Q7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5Bc3NldCAxPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTI4LDI0LjExQzE1LjI4LDM2Ljg3LDAsMjcuODUsMCwyNy44NXM3LjU2LS41NywxMC40OS0yLjkzYzAsMC01LjQ1LTIuODQtNi44My02LjU4LDAsMCwyLjE5LDEuMDYsMi43Ni45LDAsMC00Ljg4LTQtNS4zNi03LjRhNy42NCw3LjY0LDAsMCwwLDMsLjQ4Uy0uMDgsNi4wNywyLjM2LDEuNmMwLDAsNS40Nyw4LjYxLDE2LjI3LDgsMCwwLS4wOS04Ljc0LDYuODEtOS41OWE3LjY4LDcuNjgsMCwwLDEsNi41LDIuNjhMMzYuNTguNTRsLTIsMy43NGgzLjE3bC0zLjksMy4yNUEyMS40OCwyMS40OCwwLDAsMSwyOCwyNC4xMVoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgTwitterIcon as ReactComponent };